import { ActiveCampaign } from '../translations-types';

const translations: ActiveCampaign = {
  title: 'ActiveCampaign',
  description:
    'Koppel deze vestiging aan ActiveCampaign. De per-vragenlijst synchronisatie stel je in bij de vragenlijst zelf (onder de publieke link).',
  questionnaireSectionTitle: 'ActiveCampaign-synchronisatie',
  configSaved: 'Configuratie opgeslagen',
  connected: 'Verbonden',
  notConnected: 'Niet verbonden',
  connect: 'Verbinden',
  disconnect: 'Ontkoppelen',
  connectSuccess: 'Verbonden met ActiveCampaign',
  disconnectSuccess: 'Ontkoppeld van ActiveCampaign',
  accountUrl: 'Account-URL',
  accountUrlHelp: 'De API-URL uit ActiveCampaign → Settings → Developer (bijv. https://jouw-account.api-us1.com).',
  apiKey: 'API-sleutel',
  configsTitle: 'Vragenlijst-configuraties',
  addConfig: 'Toevoegen',
  questionnaire: 'Vragenlijst',
  list: 'Lijst',
  tag: 'Tag',
  triggerScope: 'Trigger',
  scopeAll: 'Alle voltooiingen',
  scopePublicOnly: 'Alleen publieke link',
  enabled: 'Actief',
  noConfigs: 'Nog geen configuraties',
  configAdded: 'Configuratie toegevoegd',
  selectQuestionnaire: 'Kies een vragenlijst',
  selectList: 'Kies een lijst',
  tagPlaceholder: 'Tag',
};

export default translations;
